<script setup lang="ts">
  import { FileQuestion } from 'lucide-vue-next';
</script>

<template>
  <div class="absolute inset-0 flex items-center justify-center p-8 pointer-events-none">
    <div class="flex flex-col items-center text-center">
      <div
        class="w-20 h-20 rounded-full bg-[var(--color-white-02)] flex items-center justify-center mb-4"
      >
        <FileQuestion class="w-10 h-10 text-gray-400" :stroke-width="1.5" />
      </div>
      <p class="text-base text-gray-600 font-medium mb-2">Canvas vazio</p>
      <p class="text-sm text-gray-500 max-w-md">
        Clique em um elemento na barra lateral para começar a criar seu formulário
      </p>
    </div>
  </div>
</template>
